import { snackBarError } from '#action/fetch';
import { webPortalApi } from '#config/web-portal-api';
import {
  AUTH_CHALLENGE_SET,
  AUTH_CHALLENGE_ERROR,
  AUTH_CHALLENGE_CLEAR,
  AUTH_CHALLENGE_RESEND_CODE_STARTED,
  AUTH_CHALLENGE_RESEND_CODE_SUCCEEDED,
  AUTH_CHALLENGE_RESEND_CODE_FAILED,
  SUCCESS,
  SUCCESS_LOGIN,
  FETCH_ACCOUNT
} from '#action/types';
import { getRequestOptions } from '#helper';
import { history } from '#configureStore';

export function resendAuthChallengeCode(data) {
  return async dispatch => {
    try {
      dispatch({
        type: AUTH_CHALLENGE_RESEND_CODE_STARTED
      });
      const response = await fetch(webPortalApi.buildUrl('/respond-to-auth-challenge'), {
        method: 'POST',
        body: JSON.stringify(data),
        ...getRequestOptions()
      });

      const result = await response.json();

      if (!response.ok) {
        dispatch({
          type: AUTH_CHALLENGE_RESEND_CODE_FAILED,
          payload: result
        });
        dispatch(
          snackBarError({
            message: 'Check credentials.',
            ...result
          })
        );

        const isSessionExpired = result?.errorMessage?.includes('Session expired');

        if (isSessionExpired) {
          dispatch({
            type: AUTH_CHALLENGE_CLEAR
          });
          sessionStorage.removeItem('authChallenge');
          history.push('/login');
        }

        return;
      }

      const { challengeName } = result;

      if (challengeName) {
        const challenge = { ...result, challengeIssuedAt: new Date().toISOString() };
        dispatch({
          type: AUTH_CHALLENGE_RESEND_CODE_SUCCEEDED,
          payload: challenge
        });
        dispatch({
          type: SUCCESS,
          payload: {
            message: 'Code resent'
          }
        });
        sessionStorage.setItem('authChallenge', JSON.stringify(challenge));
        history.push('/auth-challenge');
      }
    } catch (e) {
      console.error('Error during sign-in:', e);
      throw e;
    }
  };
}

export function respondToAuthChallenge(data, socket) {
  return async dispatch => {
    try {
      const response = await fetch(webPortalApi.buildUrl('/respond-to-auth-challenge'), {
        method: 'POST',
        body: JSON.stringify(data),
        ...getRequestOptions()
      });

      const result = await response.json();

      if (!response.ok) {
        dispatch({
          type: AUTH_CHALLENGE_ERROR,
          payload: result
        });
        dispatch(
          snackBarError({
            message: 'Check credentials.',
            ...result
          })
        );

        const isSessionExpired = result?.errorMessage?.includes('Session expired');

        if (isSessionExpired) {
          dispatch({
            type: AUTH_CHALLENGE_CLEAR
          });
          sessionStorage.removeItem('authChallenge');
          history.push('/login');
        }

        return;
      }

      const { token, challengeName } = result;

      if (challengeName) {
        const challenge = { ...result, challengeIssuedAt: new Date().toISOString() };
        dispatch({
          type: AUTH_CHALLENGE_SET,
          payload: challenge
        });
        sessionStorage.setItem('authChallenge', JSON.stringify(challenge));
        history.push('/auth-challenge');

        return;
      }
      sessionStorage.removeItem('authChallenge');
      localStorage.setItem('auth', token);

      dispatch({
        type: SUCCESS_LOGIN,
        payload: {
          message: 'Welcome!'
        }
      });

      if (result.directProjects.length) {
        const projectIds = result.directProjects;
        const projectsRes = await fetch(webPortalApi.buildApiUrl(`project?modules=true&ids=${projectIds.join(',')}`), getRequestOptions());
        result.directProjects = await projectsRes.json();
      }

      dispatch({
        type: FETCH_ACCOUNT,
        payload: result
      });

      socket.emit('authenticate', { token });

      const beforeLoginPath = localStorage.getItem('beforeLoginPath');
      if (beforeLoginPath) {
        if (beforeLoginPath === '/docs/api' || beforeLoginPath.includes('/demo/')) {
          window.location.replace(webPortalApi.buildUrl(beforeLoginPath));
        } else {
          setTimeout(() => {
            history.push(beforeLoginPath);
          }, 0);
        }
        localStorage.removeItem('beforeLoginPath');
        dispatch({
          type: AUTH_CHALLENGE_CLEAR
        });
        sessionStorage.removeItem('authChallenge');
      } else {
        setTimeout(() => {
          history.push('/');
          dispatch({
            type: AUTH_CHALLENGE_CLEAR
          });
          sessionStorage.removeItem('authChallenge');
        }, 0);
      }
    } catch (e) {
      console.error('Error during sign-in:', e);
      throw e;
    }
  };
}
